var tinymce = require('tinymce');

console.log('tinymce.init: ' + !!tinymce.init);

var tinymceService = {

    init: function(selector, type){
        var thisModule = this;

        if(type == 'inlineFull'){
            thisModule.inlineFull(selector);
        } else{
            thisModule.inlineBasic(selector);
        }


    },

    // domain : comes from scripts-handler
    inlineFull: function(selector){
        console.log('domain: ' + domain);
        var thisModule = this;
        var tinymcePluginsPath = "../../../wp-content/plugins/helpie/vendor-custom/tinymce/plugins/";

        tinymce.init({
            selector: '.helpie-article-editor .content-area .editor-content.tinymce',
            theme: 'inlite',
            plugins: 'image media link paste contextmenu textpattern autolink codesample',
            external_plugins: {
                // "table": tinymcePluginsPath + "table/plugin.min.js",
                "contextmenu": tinymcePluginsPath + "contextmenu/plugin.min.js",
                "textpattern": tinymcePluginsPath + "textpattern/plugin.min.js",
                "autolink": tinymcePluginsPath + "autolink/plugin.min.js",
                "codesample": tinymcePluginsPath + "codesample/plugin.min.js",
            },
            insert_toolbar: 'quickimage media codesample',
            selection_toolbar: 'bold italic | quicklink h2 h3 h4 h5 h6 blockquote',
            inline: true,
            paste_data_images: true,
            images_upload_url: domain + '/wp-content/plugins/helpie/features/kb/postAcceptor.php',
            automatic_uploads: true,
             media_live_embeds: true,
            init_instance_callback: function (editor) {

                    var content = tinymce.get('content-tinymce').getContent();
                    if(content == ''){
                        jQuery('.helpie-article-editor .content-area .editor-content').html('');
                    }


            }

        });
    },

    inlineBasic: function(){
        tinymce.init({
          selector: '.helpie-article-editor .content-area .title.tinymce',
          theme: 'inlite',
          inline: true,
          selection_toolbar: '',
          init_instance_callback: function (editor) {
              var content = tinymce.get('title-tinymce').getContent();
              if(content == ''){
                  jQuery('.helpie-article-editor .content-area .title').html('');
              }
          }

        });
    },

};

module.exports = tinymceService;
